// extracted by mini-css-extract-plugin
export default {"duration":"OZqI9","lockStatus":"JQasC","gift":"iJeBF","cursorInitial":"xv7tC"};